import React from "react";
var __jsx = React.createElement;
import { isTextContentType } from "./document-content";
var TEXT_CLASS = "font-mono text-style-body-small leading-relaxed whitespace-pre-wrap break-words text-sds-base-default overflow-x-auto";

/** Renders resolved document content, switching on its MIME type. */
export function DocumentContentView(_ref) {
  var content = _ref.content,
    contentType = _ref.contentType,
    name = _ref.name,
    _ref$forPrint = _ref.forPrint,
    forPrint = _ref$forPrint === void 0 ? false : _ref$forPrint;
  if (contentType === "text/html") {
    return /*#__PURE__*/React.createElement("div", {
      className: TEXT_CLASS,
      dangerouslySetInnerHTML: {
        __html: content
      }
    });
  }
  if (isTextContentType(contentType)) {
    return /*#__PURE__*/React.createElement("div", {
      className: TEXT_CLASS
    }, content);
  }
  if (forPrint) {
    return /*#__PURE__*/React.createElement("p", {
      className: "text-style-body-small text-sds-base-secondary"
    }, name);
  }
  return /*#__PURE__*/React.createElement("iframe", {
    src: content,
    title: name,
    className: "h-full min-h-[500px] w-full rounded-sds-200 border border-sds-base-default",
    style: {
      maxHeight: "70vh"
    }
  });
}